import { _t } from "core/language";
import MoreIcon from "../assets/icon/more.svg";
import LoginItem from "core/components/LoginItem";
const FavoriteNoAuth = () => {

  return (
    <section className="mt-2 py-[30px] w-full bg-white">
      <div className="flex justify-between items-center">
        <h1 className="text-[17px] font-bold text-[#111111]  px-4">
          {_t("main.favorite_title")}
        </h1>
        <img className="mr-2" src={MoreIcon} alt="" />
      </div>
      <LoginItem label={_t("main.favorite_login")} className="pt-[12px] !mb-0" classLabel="!mb-[30px]" classBtn="!px-[40px] max-h-[34px]" />
    </section>
  );
};

export default FavoriteNoAuth;
